// extracted by mini-css-extract-plugin
module.exports = {"more":"src-components-UI-GridApps-GridApps-module__more--2GCVH","flex":"src-components-UI-GridApps-GridApps-module__flex--2CiN3"};